import i18n from "../i18n";
import Proof from "../components/ProofOfVaccination";
import VaccineDoses from "../components/VaccineDoses";
import vaccineService from "../services/vaccination.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useTranslation, Trans } from "react-i18next";
import React, { useEffect, useState } from "react";
import Spinner from "../components/Spinner";
import ProfileNotification from "../components/ProfileNotification";

const VaccineLicenseInternal = () => {
  const [vaccinationCardInfo, setVaccinationCardInfo] = useState([]);
  const [errors, setErrors] = useState([]) as any;
  const [issueDate, setIssueDate] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [loading, setLoading] = useState(false);

  const notify = (text: string) => {
    toast(<ProfileNotification text={text} />, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      closeButton: false,
      progress: undefined,
    });
  };

  const { t } = useTranslation();
  const getInternalVaccinationCard = async () => {
    try {
      setLoading(true);
      const { data } = await vaccineService.getInternalVaccinationCard();
      setIssueDate(data.issueDate);
      setQrCode(data.qrCode);
      const vaccinationCard = data.vaccinationInfos;
      // const temp: any = [{}, {}, {}];
      // vaccinationCard.forEach((item: any, index: any) => {
      //   return temp.fill(item, index, ++index);
      // });
      setVaccinationCardInfo(vaccinationCard);
    } catch (error: any) {
      console.log(error);
      if (error.response) {
        notify(error.response.data?.message || "خطا در اتصال به سرور");
        if (error.response.status >= 500) {
          setErrors([{ field: "", message: "خطا در دریافت اطلاعات" }]);
        }
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        // console.log("Error", error.message);
        setErrors([{ field: "", message: error.message }]);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getInternalVaccinationCard();
  }, []);

  return (
    <>
      <ToastContainer rtl />
      <div className="vaccine-license">
        {loading ? (
          <div className="u-margin-top-big">
            <Spinner />
          </div>
        ) : (
          <div className={`proof-of-vaccination-wrapper ${i18n.dir()}`}>
            <Proof.ProofOfVaccination>
              <Proof.OwnerSectionTop qrCode={qrCode} errors={errors} />
              <Proof.OwnerSectionMiddle />
              <Proof.OwnerSectionBottom issueDate={issueDate} />
            </Proof.ProofOfVaccination>

            <div className="vaccination-detail-wrapper">
              <h4 className="title">{t("Vaccination")}</h4>

              {vaccinationCardInfo.length
                ? vaccinationCardInfo.map((info: any, i: any) => {
                    return <VaccineDoses index={i} key={i} data={info} />;
                  })
                : null}

              <div className="vaccination-detail-card notice text-xl">
                <div className="pb-5 text-gray-600">
                  <Trans i18nKey="pages__vaccine__description">
                    {/* eslint-disable-next-line */}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-navy-900 text-decoration-underline"
                      href="https://health.gov.ir"
                    />
                  </Trans>
                </div>
                <div className="text-navy-900 u-d-flex flex-column">
                  <span>{t("pages__vaccine__note")}</span>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-center u-margin-top-small-1"
                    href="https://vaccine.health.gov.ir"
                  >
                    https://vaccine.health.gov.ir
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VaccineLicenseInternal;
